import { Grid, TableRow } from "@mui/material";
import { Fragment } from "react/jsx-runtime";
import {
  BlastRadiusCell,
  ImpactCell,
  PublishedCell,
  RiskFactorsCell,
  TitleCell,
} from "~/components/Cells";
import { GenericTable } from "~/components/GenericTable/GenericTable";
import { DynamicIcon } from "~/components/icons/DynamicIcon";
import { ScoreRating } from "~/operations";
import { spacing } from "~/pages/reports/utils/reportsConstants";
import { useChecksOrVulnerabilitiesReport } from "../hooks/useChecksOrVulnerabilities";
import { ReportType } from "~/reportApp/reportingApp";
import { ReportsSectionHeading } from "~/pages/reports/components/ReportsSectionHeading";
import { ReportsNoItemsSection } from "~/pages/reports/components";

export function VulnerabilitiesReportsTable() {
  const { foundVulns, foundAdvisories } = useChecksOrVulnerabilitiesReport({
    reportType: ReportType.Vulnerabilities,
  });

  return (
    <Fragment>
      <Grid size={12} sx={{ mb: spacing[50] }}>
        {[foundVulns, foundAdvisories].map((group) => {
          if (!group) return null;
          return (
            <Fragment key={group.heading}>
              <ReportsSectionHeading
                heading={group.heading}
                dividerContent={`${group.total} Total`}
              />
              <Grid size={12} sx={{ my: 3 }}>
                {!group.items ? (
                  <ReportsNoItemsSection target="Checks" />
                ) : (
                  <GenericTable
                    items={0}
                    tableName="VULNERABILITIES_REPORT_TABLE"
                    validSortFields={[]}
                    printView
                  >
                    {group.items?.map((item) => {
                      const {
                        id,
                        riskValue,
                        rating,
                        title,
                        iconId,
                        tags,
                        riskFactors,
                        blastRadius,
                        lastScannedAt,
                      } = item.node || {};

                      return (
                        <TableRow key={id}>
                          <BlastRadiusCell
                            blastRadius={blastRadius}
                            impact={riskValue || 0}
                            rating={rating || ScoreRating.Unscored}
                            isActive={rating == null ? false : true}
                          />
                          <ImpactCell
                            impact={riskValue || 0}
                            rating={rating || ScoreRating.Critical}
                            isActive={rating == null ? false : true}
                            hideTooltip
                          />

                          <TitleCell
                            title={title || ""}
                            {...(group.heading === "Found advisories" && {
                              icon: <DynamicIcon iconId={iconId} />,
                            })}
                            tags={tags}
                            options={{ fontSize: 14 }}
                          />
                          <RiskFactorsCell
                            riskFactors={riskFactors}
                            printView
                          />
                          <PublishedCell date={lastScannedAt || "Never"} />
                        </TableRow>
                      );
                    })}
                  </GenericTable>
                )}
              </Grid>
            </Fragment>
          );
        })}
      </Grid>
    </Fragment>
  );
}
